import React from "react";
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from "react-intl";
import AbstractTable from "../../../components/common/dumb-components/abstract-table-component";
import withStyles from "../../../components/with-styles/with-styles";
import styles from "./styles.css";
import OptionalDate from "../../../components/optional-date/optional-date";
import IconButton from "../../../components/icon-button/icon-button";
import DownloadIcon from "../../../components/buttons/download-button/parts/download-icon";
import {DEFAULT_PAGINATION_SIZE, rowsPerPageOptions} from "../../../components/table/paginated-table/context";
import cn from "classnames";
import {MATERIAL_UI_THEME} from "../../../utils/constants";


const LocalRecordingsTableComponent = ({intl, classes, data, handleDownload, loadingDownload}) => {

    const materialUiTheme = MATERIAL_UI_THEME();

    return (
        <AbstractTable
            columns={[
                {
                    render: rowData => <div
                        className={cn(classes.title, {[classes.main]: rowData.event_id === 'continuous'})}>{rowData.recording_id}</div>
                },
                {
                    render: rowData => <div className={classes.date_wrapper}>
                        <div className={classes.date_container}>
                            <OptionalDate
                                label={intl.formatMessage({id: "event.startDate"})}
                                className={cn(classes.date, {
                                    [classes.main]: rowData.event_id === 'continuous',
                                    [classes.date__finished]: rowData.event_id !== 'continuous'
                                })}
                                icon="event-available"
                                value={rowData.start}
                            />
                            <OptionalDate
                                label={intl.formatMessage({id: "event.endDate"})}
                                className={cn(classes.date, {
                                    [classes.main]: rowData.event_id === 'continuous',
                                    [classes.date__finished]: rowData.event_id !== 'continuous'
                                })}
                                icon="event-available"
                                value={rowData.end}
                            />
                        </div>
                    </div>,
                    cellStyle: {
                        textAlign: 'center'
                    }
                },
                {
                    render: rowData => <div className={classes.rowButtonsContainer}>
                        <div className={cn(classes.waitingText, {[classes.main]: rowData.event_id === 'continuous'})}>
                            {rowData.event_id === 'continuous' && <FormattedMessage id="recording.download.waiting"/>}
                        </div>
                        {loadingDownload === rowData.recording_id ?
                            <div className={classes.waitingText}>
                                <FormattedMessage id="recording.download.loading"/>
                            </div> :
                            <IconButton onClick={() => handleDownload(rowData)}
                                        disabled={rowData.event_id === 'continuous'}
                                        className={cn(classes.recording_download__main, {[classes.recording_download__main__disabled]: rowData.event_id === 'continuous'})}>
                                <DownloadIcon compactStyle={true} disabled={rowData.event_id === 'continuous'}
                                              disabledClass={classes.recording_download__main__disabled}/>
                            </IconButton>
                        }
                    </div>,
                    cellStyle: {
                        textAlign: 'right'
                    }
                }
            ]}
            data={data || []}
            options={{
                actionsColumnIndex: -1,
                showEmptyDataSourceMessage: true,
                doubleHorizontalScroll: false,
                pageSize: DEFAULT_PAGINATION_SIZE,
                pageSizeOptions: rowsPerPageOptions,
                search: false,
                toolbar: false,
                header: false,
                hover: false,
                rowStyle: rowData => (rowData.event_id === 'continuous' && {
                    backgroundColor: materialUiTheme.palette.blue.light
                })
            }}
            intl={intl}
        />
    );
};


LocalRecordingsTableComponent.propTypes = {
    data: PropTypes.array.isRequired,
    handleDownload: PropTypes.func.isRequired,
    loadingDownload: PropTypes.any
};

export default withStyles(styles)(injectIntl(LocalRecordingsTableComponent));